import { render, staticRenderFns } from "./DatepickerCustom.vue?vue&type=template&id=0564518a&"
import script from "./DatepickerCustom.vue?vue&type=script&lang=js&"
export * from "./DatepickerCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports